"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerHiddenData = exports.getGetCustomerHiddenDataUrl = void 0;
const constants_1 = require("../../constants/index.js");
const getGetCustomerHiddenDataUrl = (customerId) => `${constants_1.VD_CUSTOMER_API_URL}/customers/${customerId}/hidden-data`;
exports.getGetCustomerHiddenDataUrl = getGetCustomerHiddenDataUrl;
/**
 * Serviço para obter dados mascarados do Cliente Final não autenticado.
 * @param customerId ID do Cliente Final
 * @param abortSignal Um AbortSignal opcional para cancelar a requisição
 * @returns {Promise<CustomerHiddenData>} Promise com os dados mascarados do cliente
 * @example
 * {
 *   "familyName": "**oe",
 *   "givenName": "J***",
 *   "whatsapp": "+55*******99"
 * }
 */
function getCustomerHiddenData(customerId, abortSignal) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch((0, exports.getGetCustomerHiddenDataUrl)(customerId), {
            signal: abortSignal,
        });
        const responseData = yield response.json();
        if (!response.ok) {
            throw responseData;
        }
        validateResponse(responseData);
        return responseData;
    });
}
exports.getCustomerHiddenData = getCustomerHiddenData;
function validateResponse(responseData) {
    if (responseData == null || typeof responseData !== 'object') {
        throw new Error('Response data is nullable');
    }
    const customerHiddenDataProps = [
        'familyName',
        'givenName',
        'whatsapp',
    ];
    const responseAsObject = responseData;
    const customerPropsMap = customerHiddenDataProps.filter((prop) => responseAsObject[prop] == null);
    if (customerPropsMap.length > 0) {
        throw new Error(`Missing properties: ${customerPropsMap.join(', ')}`);
    }
}
